import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';

// 配置 dayjs
dayjs.extend(relativeTime);
dayjs.locale('zh-cn');

export function formatDate(date?: string | number | Date | null, format = 'yyyy-MM-dd HH:mm:ss'): string {
  if (!date) return '';
  const dj = dayjs(date);
  if (!dj.isValid()) return String(date);
  const year = dj.year();
  const month = String(dj.month() + 1).padStart(2, '0');
  const day = String(dj.date()).padStart(2, '0');
  const hours = String(dj.hour()).padStart(2, '0');
  const minutes = String(dj.minute()).padStart(2, '0');
  const seconds = String(dj.second()).padStart(2, '0');

  const formattedDate = format
    .replace('yyyy', String(year))
    .replace('MM', month)
    .replace('dd', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);

  return formattedDate;
}

/**
 * 格式化相对时间（如：刚刚、5分钟前、2小时前等）
 * @param date - 日期对象、日期字符串或时间戳
 * @returns 格式化后的相对时间字符串
 */
export function formatRelativeTime(date?: string | number | Date | null): string {
  if (!date) return '';

  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) return '';
  const now = dayjs();
  const diffInSeconds = Math.abs(now.diff(dayjsDate, 'second'));

  // 小于1分钟显示"刚刚"
  if (diffInSeconds < 60) {
    return '刚刚';
  }

  // 小于7天显示相对时间（如：5分钟前、2小时前、3天前）
  if (diffInSeconds < 7 * 24 * 60 * 60) {
    return dayjsDate.fromNow();
  }

  // 超过7天显示具体日期和时间
  return dayjsDate.format('YYYY-MM-DD HH:mm:ss');
}

export default {
  formatDate,
  formatRelativeTime
};
